export default {
    'SETTINGS.ROLE.EDIT.POPUP.TITLE': 'Modifier une fonction',
    'SETTINGS.ROLE.ADD.POPUP.TITLE': 'Ajouter une fonction',
    'SETTINGS.ROLE.SUBTITLE': 'Veuillez assigner au moins un droit',
    'SETTINGS.ROLE.NAME.LABEL': 'Nom de la fonction',
    'SETTINGS.ROLE.NAME.PLACEHOLDER': 'Donnez un nom à cette nouvelle fonction',
    'SETTINGS.ROLE.APPOINTMENT.TITLE': 'Rendez-vous',
    'SETTINGS.ROLE.APPOINTMENT.BOOK': 'Réserver un rendez-vous',
    'SETTINGS.ROLE.APPOINTMENT.CANCEL': 'Annuler un rendez-vous',
    'SETTINGS.ROLE.APPOINTMENT.RESSOURCES': 'Ressources',
    'SETTINGS.ROLE.APPOINTMENT.CONSULT': 'Consulter',
    'SETTINGS.ROLE.APPOINTMENT.VIEW': 'Voir',
    'SETTINGS.ROLE.APPOINTMENT.WORKERS': 'Conseillers',
    'SETTINGS.ROLE.APPOINTMENT.CONFIGURATION': 'Configuration',
    'SETTINGS.ROLE.APPOINTMENT.REMINDERS': 'Rappels des rendez-vous',
    'SETTINGS.ROLE.APPOINTMENT.EDIT.ACCOUNT': 'Modifier compte',
    'SETTINGS.ROLE.APPOINTMENT.CONSULT.STATISTICS': 'Consulter les statistiques',
    'SETTINGS.ROLE.APPOINTMENT.STATISTICS': 'Statistiques',
    'SETTINGS.ROLE.APPOINTMENT.ANONYMISE.CALENDAR': 'Anonymiser le calendrier',
    'SETTINGS.ROLE.APPOINTMENT.CONSULT.VIEW': 'Consulter la vue calendrier',
    'SETTINGS.ROLE.APPOINTMENT.EDIT.VIEW': 'Modifier la vue calendrier',
    'APPOINTMENT.TITLE.CANCELED': 'L\'intervention a bien été annulée',
    'appointment_booking': 'Prendre des rendez-vous',
    'appointment_cancelling': 'Annuler des rendez-vous',
    'SETTINGS.ROLE.COMPANIES.TITLE': 'Sociétés',
    'company_list_consulting': 'Consulter la liste des sociétés',
    'company_list_cancelling': 'Supprimer une société',
    'company_calendar_consulting': 'Consulter le calendrier des sociétés',
    'company_list_adding': 'Ajouter une société',
    'company_list_editing': 'Modifier une société',
    'SETTINGS.ROLE.WORKERS.TITLE': 'Ressources',
    'worker_list_consulting': 'Consulter la liste des ressources',
    'worker_list_cancelling': 'Supprimer une ressource',
    'worker_list_adding': 'Ajouter une ressource',
    'worker_calendar_consulting': 'Consulter le calendrier des ressources',
    'worker_list_editing': 'Modifier une ressource',
    'SETTINGS.ROLE.DELETE': 'Supprimer cette fonction',
    'settings_adding_team_member': 'Ajouter un utilisateur',
    'SETTINGS.ROLE.REQUIRED.FIELD': 'Champ obligatoire',
    'SETTINGS.ROLE.DELETE.TITLE': 'Supprimer une fonction',
    'SETTINGS.ROLE.DELETE.TXT': 'Souhaitez-vous vraiment supprimer cette fonction?',
    'SETTINGS.ROLE.DELETE.BUTTON.CONFIRM': 'Oui, supprimer',
    'SETTINGS.ROLE.DELETE.BUTTON.CANCEL': 'Annuler',
    'settings_editing_team_member': 'Modifier un utilisateur',
    'settings_deleting_team_member': 'Supprimer un utilisateur',
    'settings_adding_role': 'Ajouter une fonction',
    'settings_editing_role': 'Modifier une fonction',
    'settings_deleting_role': 'Supprimer une fonction',
    'SETTINGS.POPUP.UPDATED': 'Les données ont été mises à jour',
};
